import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';

import GlobalErrorBoundary from './components/GlobalErrorBoundary.js';

const root = createRoot(document.getElementById('root'));
root.render(
    React.createElement(GlobalErrorBoundary, null,
        React.createElement(App)
    )
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(err => {
            console.error('Service Worker registration failed:', err);
        });
    });
}
